<template>
  <div id="tabs">
    <div>
      <div class="tabs-btn" v-if="itens" :style="`width: ${width}%`">
        <div style="width: 575px; display: contents">
          <div style="width: 510px">
            <el-tabs refs="tabs" v-model="active"  @tab-click="handleClick" :style="'--cor-primary:' + corSecundaria" class="margin-top">
              <el-tab-pane v-for="(item) in lista" :key="item" :name="item">
                <template slot="label">
                  <span :style="'color:' + corPrimaria" class="dia-mes tab-style-bold">{{formatData(item)}}</span>
                  <span :style="'color:' + corPrimaria" class="nome-dia tab-style">{{parseDateName(item)}}</span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div>
              <div class="border-bottom">
                <el-button
                  @click="openCalendar()"
                  :style="'color:' + corPrimaria"
                  class="btn-tab"
                  type="text">
                  Ver mais
                </el-button>
                <el-date-picker
                  type="date"
                  size="mini"
                  @change="clickDate($event)"
                  ref="datePicker"
                  v-model="active2"
                  :picker-options="pickerOptions"
                  placeholder="Pick a day">
                </el-date-picker>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      dataSelecionada: null,
      startDate: null,
      lista: [],
      active: '',
      active2: '',
      pickerOptions: {
        disabledDate: this.disableDates
      }
    }
  },
  name: 'agendaTab',
  props: {
    itens: {
      type: Array
    },
    width: {
      type: Number,
      default: 100
    },
    value: {},
    initialValue: {},
    initial: {
      type: Number,
      default: 0
    }
  },
  watch: {
    initialValue () {
      this.init()
    },
    initial: {
      handler () {
        this.init()
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('SetupApp', ['funcionalidade']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corSecundaria () {
      return this.estilo.aplicacao.corSecundariaAplicacao
    },
    maxDias () {
      return this.funcionalidade.parametros.maxDiasVerMais
    },
    datePickerDays () {
      const deleteDuplicate = [...new Set(this.itens)]
      return deleteDuplicate
    }
  },
  methods: {
    formatData (data) {
      return moment(data, moment.defaultFormat).format('DD/MM')
    },
    disableDates (date) {
      const day = moment(date).format('YYYY-MM-DD')
      return this.datePickerDays.indexOf(day) === -1
    },
    parseDateName (value) {
      const data = moment(value, 'YYYY-MM-DD HH:mm:ss')
      return data.locale('pt-br').format('ddd')
    },
    handleClick (obj, e) {
      this.$emit('input', obj.$vnode.key)
    },
    clickDate (data) {
      const formated = moment(data).format('YYYY-MM-DD')
      if (this.lista.indexOf(formated) === -1) {
        let index = this.maxDias
        this.$set(this.lista, index, formated)
      }
      this.active = formated
      this.active2 = formated
      this.$emit('input', formated)
    },
    openCalendar () {
      this.$refs.datePicker.focus()
    },
    init () {
      this.lista = this.itens.slice(0, this.maxDias)
      this.active = this.initialValue
      const convertDate = this.lista.map(item => {
        return moment(item).format('YYYY/MM/DD')
      })
      const initialDay = moment(this.initialValue).format('YYYY/MM/DD')
      this.active2 = initialDay
      if (convertDate.indexOf(initialDay) === -1) {
        this.lista.push(this.active)
      }
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');

.btn-tab {
  font-family: "Open Sans", SansSerif;
}

.el-tabs__active-bar is-top {
  background-color: var(--cor-primary);
}
</style>
